import { immerable } from 'immer';
import { GeoPoint } from './geo-point';

export class WayPoint extends GeoPoint {
    public static [immerable] = true;

    public timestamp: Date;
    public distanceInKilometers: number;

    constructor(params?: Partial<WayPoint>) {
        super(params);
        if (params) {
            this.timestamp = new Date(params.timestamp) || this.timestamp;
            this.distanceInKilometers = params.distanceInKilometers || this.distanceInKilometers;
        }
    }
}
